import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7db1a497"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  class: "userinfo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "nickname" }
const _hoisted_7 = { class: "g-card topup" }
const _hoisted_8 = { class: "topup-content" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "当前余额", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "balance"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "yuan" }, " ¥ ", -1))
const _hoisted_14 = {
  key: 1,
  class: "balance"
}
const _hoisted_15 = { class: "ctrl" }
const _hoisted_16 = { class: "g-card content" }
const _hoisted_17 = { class: "menu menu-user" }
const _hoisted_18 = { class: "left-menu" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "绑定邀请码", -1))
const _hoisted_20 = {
  key: 0,
  class: "team-code"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "tip" }
const _hoisted_23 = {
  key: 1,
  class: "team-code"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tip" }, "您已是注册用户，无法绑定", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 2,
  class: "team-code"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tip" }, "点击绑定", -1))
const _hoisted_28 = { class: "left-menu" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "我的邀请码", -1))
const _hoisted_30 = { class: "left-menu" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "我的团队", -1))
const _hoisted_32 = { class: "left-menu" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "我的优惠券", -1))
const _hoisted_34 = { class: "g-card content" }
const _hoisted_35 = { class: "menu" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-menu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-icon-warehouse menu-icon-img" }),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "中转仓地址")
], -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-menu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-icon-address menu-icon-img" }),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "地址库")
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-menu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-icon-service menu-icon-img" }),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "客服")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-menu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-icon-rule menu-icon-img" }),
  /*#__PURE__*/_createElementVNode("div", { class: "menu-title" }, "转运规则与说明")
], -1))
const _hoisted_40 = {
  key: 0,
  class: "g-modal is-center team-code-modal"
}
const _hoisted_41 = { class: "g-modal-body" }
const _hoisted_42 = { class: "modal-content" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "填写邀请码", -1))
const _hoisted_44 = { class: "logistics-code-input" }
const _hoisted_45 = {
  "hover-class": "hover",
  class: "footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.userInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "avatar",
                src: _ctx.info.avatarUrl
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.info.nickname), 1),
                (_ctx.userInfo.userCode)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args))),
                      class: "code"
                    }, " 编号：" + _toDisplayString(_ctx.userInfo.userCode), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Icon, {
                class: "g-icon",
                onClick: _withModifiers(_ctx.showBalance, ["stop"]),
                icon: _ctx.isShowBalance ? 'btn_my_open_eye' : 'btn_my_eye'
              }, null, 8, ["onClick", "icon"])
            ]),
            (_ctx.isLogin)
              ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                  (_ctx.isShowBalance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _createTextVNode(_toDisplayString(_ctx.userInfo.balance), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, "* * * *"))
                ]))
              : (_openBlock(), _createElementBlock("section", {
                  key: 1,
                  class: "unlogin-balance",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navLogin && _ctx.navLogin(...args)))
                }, " 立即登录后查看 "))
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.isLogin)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "ctrl-item",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.replaceCharge && _ctx.replaceCharge(...args)))
                }, " 充值 "))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "ctrl-item",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.navLogin && _ctx.navLogin(...args)))
                }, "充值")),
            _createElementVNode("div", {
              class: "ctrl-item",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redirectToCash && _ctx.redirectToCash(...args)))
            }, "提现"),
            _createElementVNode("div", {
              class: "ctrl-item",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.redirectToTranList && _ctx.redirectToTranList(...args))),
              "hover-class": "hover"
            }, " 账单明细 ")
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showBindTeamQrcode && _ctx.showBindTeamQrcode(...args)))
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_Icon, {
                  class: "menu-icon",
                  icon: "icon_invite"
                }),
                _hoisted_19
              ]),
              (_ctx.userInfo.parentId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("img", {
                      class: "avatar",
                      src: _ctx.userInfo.parentInfo.image
                    }, null, 8, _hoisted_21),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.userInfo.parentInfo.name), 1)
                  ]))
                : (_ctx.hasOrder)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_Icon, {
                        class: "arrow-right",
                        icon: "btn_arrow_right"
                      })
                    ]))
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              "hover-class": "hover",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.navToShare && _ctx.navToShare(...args)))
            }, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_Icon, {
                  class: "menu-icon",
                  icon: "icon_share"
                }),
                _hoisted_29
              ]),
              _createVNode(_component_Icon, {
                class: "arrow-right",
                icon: "btn_arrow_right"
              })
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.navMyTeam && _ctx.navMyTeam(...args)))
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Icon, {
                  class: "menu-icon",
                  icon: "icon_team"
                }),
                _hoisted_31
              ]),
              _createVNode(_component_Icon, {
                class: "arrow-right",
                icon: "btn_arrow_right"
              })
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.navMyCoupon && _ctx.navMyCoupon(...args))),
              "hover-class": "hover"
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_Icon, {
                  class: "menu-icon",
                  icon: "quan"
                }),
                _hoisted_33
              ]),
              _createVNode(_component_Icon, {
                class: "arrow-right",
                icon: "btn_arrow_right"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.navWareHouseList && _ctx.navWareHouseList(...args))),
              "hover-class": "hover",
              "data-path": "/my/warehouse/index"
            }, [
              _hoisted_36,
              _createVNode(_component_Icon, {
                class: "arrow-right",
                icon: "btn_arrow_right"
              })
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.redirectToAddressList && _ctx.redirectToAddressList(...args)))
            }, [
              _hoisted_37,
              _createVNode(_component_Icon, {
                class: "arrow-right",
                icon: "btn_arrow_right"
              })
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.redirectToService && _ctx.redirectToService(...args)))
            }, [
              _hoisted_38,
              _createVNode(_component_Icon, {
                class: "arrow-right",
                icon: "btn_arrow_right"
              })
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.redirectToRule && _ctx.redirectToRule(...args))),
              "hover-class": "hover",
              "data-path": "/my/rule/index"
            }, [
              _hoisted_39,
              _createVNode(_component_Icon, {
                class: "arrow-right",
                icon: "btn_arrow_right"
              })
            ])
          ])
        ])
      ])
    ]),
    (_ctx.dialogVisiable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _withDirectives(_createElementVNode("input", {
                  type: "g-input",
                  "cursor-spacing": "100",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.leaderCode) = $event)),
                  placeholder: "邀请码绑定后无法更改"
                }, null, 512), [
                  [_vModelText, _ctx.leaderCode]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", {
                class: "btn",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogVisiable = false))
              }, "取消"),
              _createElementVNode("div", {
                class: "btn btn-submit",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.bindLeaderCode && _ctx.bindLeaderCode(...args)))
              }, "绑定")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}